import { render, staticRenderFns } from "./NomineeIDPreviewPopup.vue?vue&type=template&id=b6b2306c&"
import script from "./NomineeIDPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./NomineeIDPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports